import * as React from "react";
const InfoIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clip-path="url(#clip0_1616_8608)">
        <path
          d="M9.96995 6.09082H9.93965C9.57601 6.09082 9.24268 6.39385 9.24268 6.78779C9.24268 7.18173 9.54571 7.48476 9.93965 7.48476H9.96995C10.3336 7.48476 10.6669 7.18173 10.6669 6.78779C10.6669 6.39385 10.3639 6.09082 9.96995 6.09082Z"
          fill="#E5637F"
        />
        <path
          d="M9.96992 8.48535C9.60628 8.48535 9.27295 8.78838 9.27295 9.18232V13.849C9.27295 14.2126 9.57598 14.546 9.96992 14.546C10.3336 14.546 10.6669 14.2429 10.6669 13.849V9.15202C10.6669 8.78838 10.3639 8.48535 9.96992 8.48535Z"
          fill="#E5637F"
        />
        <path
          d="M9.9699 0.848633C4.9093 0.848633 0.788086 4.93954 0.788086 10.0001C0.788086 15.0608 4.9093 19.182 9.9699 19.182C15.0305 19.182 19.1214 15.0608 19.1214 10.0001C19.1214 4.93954 15.0305 0.848633 9.9699 0.848633ZM9.9699 17.8183C5.66687 17.8183 2.15172 14.3032 2.15172 10.0001C2.15172 5.69712 5.66687 2.18197 9.9699 2.18197C14.2729 2.18197 17.7578 5.69712 17.7578 10.0001C17.7578 14.3032 14.2729 17.8183 9.9699 17.8183Z"
          fill="#E5637F"
        />
      </g>
      <defs>
        <clipPath id="clip0_1616_8608">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default InfoIcon;
